export * from '@primeuix/themes/material/message';
export { default } from '@primeuix/themes/material/message';
